'use client'

import { Pencil, ScrollText } from 'lucide-react'

import { useAutomations } from '~/app/automations/useAutomations'
import { AutomationPolicyDisplay } from '~/components/automations/AutomationPolicyDisplay'
import { TriggerAutomationButton } from '~/components/automations/TriggerAutomationButton'
import { Button } from '~/components/component-library'
import { SplitsDialogContent } from '~/components/component-library/Dialog'
import { useAuth } from '~/context/AuthProvider'

export const AutomationActionButtons = ({
  smartAccountId,
  isDisabled,
}: {
  smartAccountId: string
  isDisabled?: boolean
}) => {
  const { automations, isLoading } = useAutomations()
  const automation = automations.find(
    (a) => a.smartAccountId === smartAccountId,
  )
  const { setGlobalModalState } = useAuth()

  if (!automation && !isLoading) return null

  const buttonsDisabled = isDisabled || !automation

  return (
    <>
      <Button
        variant="secondary"
        prefix={<ScrollText />}
        isDisabled={buttonsDisabled}
        onClick={() => {
          if (!automation) return
          setGlobalModalState({
            isOpen: true,
            content: (
              <SplitsDialogContent
                id="automationPolicy"
                title="Policy"
                variant="info"
              >
                <AutomationPolicyDisplay policy={automation.policy} />
              </SplitsDialogContent>
            ),
          })
        }}
      >
        Policy
      </Button>
      <Button
        variant="secondary"
        prefix={<Pencil />}
        isDisabled={buttonsDisabled}
        href={
          automation
            ? { path: `/automations/${automation.id}/edit` }
            : undefined
        }
      >
        Edit
      </Button>
      <TriggerAutomationButton
        automation={automation}
        isDisabled={isDisabled}
      />
    </>
  )
}
